Vue.use(window.VueDragscroll)

const app = new Vue({
  el: '#app',
  data: {
    team: null,
    series: {},
  },
  async created() {
    const found = window.location.pathname.match(/\/(\d+)$/)
    const teamId = found[1]

    // 開催中の公式戦データを取得する
    const {
      data: { entries },
    } = await axios.post('/api/collections/get/series', {
      filter: {
        isCurrentSeries: true,
        published: true,
      },
      sort: { type: 1 },
    })

    const seriesIds = entries.map((item) => {
      return item._id
    })

    // チームデータを取得する
    for (const seriesId of seriesIds) {
      const {
        data: {
          entries: [team]
        }
      } = await axios.post('/api/collections/get/seriesTeams', {
        filter: { seriesId, teamId },
      })

      this.team = team
      if (!_.isEmpty(team)) break
    }

    this.series = entries.find((item) => {
      return item._id === this.team.seriesId
    })
  },
  computed: {
    players() {
      return this.team.members.filter((member) => {
        return member.role === 'player' && !_.includes(member.update, '抹消')
      })
    },
    staffs() {
      return this.team.members.filter((member) => {
        return member.role === 'staff' && !_.includes(member.update, '抹消')
      })
    },
  }
})
